'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { OrderDate } from 'my-purchases/components/Card/components/OrderDate/OrderDate'
import { OrderId } from 'my-purchases/components/OrderCard/content/OrderId/OrderId'
import type { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import { useMemo } from 'react'
import { dateFormatter } from 'utils/dateFormatter/dateFormatter'

import fukkuStyles from 'fukku/styles/classes.module.scss'
import styles from './OrderInfo.module.scss'

interface OrderInfoProps {
	readonly orderIds: string[]
	readonly orderLineCount: number
	readonly type?: ORDER_TYPES
	readonly date?: string
}

export function OrderInfo({
	orderIds,
	type,
	orderLineCount,
	date,
}: OrderInfoProps) {
	const { t } = useLabels()
	const {
		country: { locale },
	} = useMasterData()
	const formattedDate = date && dateFormatter({ dateString: date, locale })

	const typeDescription = type
		? `${t(`my_purchases.order.type_${type.toLowerCase()}`)} | `
		: ''

	const typeA11y = type
		? t(`accessibility.myPurchases.${type.toLowerCase()}Purchase.text`)
		: ''

	const orderIdLine = useMemo(() => {
		return orderIds.map((id) => <OrderId key={id} type={type} orderId={id} />)
	}, [orderIds])

	return (
		<div className={styles.info}>
			{orderIdLine}
			{orderLineCount > 0 && (
				<>
					<p
						className={fukkuStyles.srOnly}
					>{`${typeA11y}, ${orderLineCount} ${t('my_purchases.receipt.items').toLowerCase()}`}</p>
					<p aria-hidden className={styles.description}>
						{`${typeDescription} ${orderLineCount} ${t('my_purchases.receipt.items').toLowerCase()}`}
					</p>
				</>
			)}
			{formattedDate && <OrderDate date={formattedDate} />}
		</div>
	)
}
